<template>
  <div id="calculator_covid" class="EduTaxRebateWidgetGovMB">
    <!-- access root props via App -->
    <router-view />
    <v-popover></v-popover>
  </div>
</template>

<script>
export default {
  props: ['lang'],
  data () {
    return {
    }
  },
  created () {
    if (this.$router) {
      this.$router.push({ name: "home"});
    }
    if (this.$store) {
      this.$store.state.lang = this.lang;
    }
    if (this.lang == "fr") {
      this.$i18n.locale = "fr-CA";
    } else {
      this.$i18n.locale = "en-CA";
    }

    this.$moment.locale(this.lang);


  },
  methods: {
  },
  watch: {
  }
}
</script>
<style lang="scss">
@import 'scss/_config';
@import 'scss/_tooltip';
</style>
